import React from 'react'

 const Load=()=>( <div style={{color:"red"}}>Loading...</div>)


 export default Load